export default "__VITE_ASSET__a9913c7b__"